//@flow

import HistoryModal from "./HistoryModal"

export default HistoryModal



// WEBPACK FOOTER //
// ./src/Kiosk/HistoryModal/index.js